import {
  MetaData,
  NormalizedProduct,
  Product,
} from "../../pages/product-catalogue-print-mth/product-catalogue-print.type";
import { useEffect, useState } from "react";
import { axios } from "../constants/api";

export const useProduct = (productId?: string) => {
  const [product, setProduct] = useState<NormalizedProduct | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!productId) return;
    const fetchProduct = async () => {
      try {
        const fetchedProduct = await axios.get<Product>(
          `/products/panel/${productId}`
        );

        if (fetchedProduct.data) {
          const metaDataObj = fetchedProduct.data.meta_data.reduce(
            (acc, curr) => {
              acc[curr.key] = curr;
              return acc;
            },
            {} as Record<string, MetaData>
          );

          const normalized: NormalizedProduct = {
            ...fetchedProduct.data,
            metaDataObj,
          };

          setProduct(normalized);
          setError(null);
        }
      } catch (err: any) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProduct();
  }, [productId]);

  return { product, isLoading, error };
};
